import React, { useState } from 'react';
import './App.css';

function App() {
  const [form, setForm] = useState({ nombre: '', correo: '', numero: '', archivo: null });
  const [empleados, setEmpleados] = useState([]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.nombre || !form.correo || !form.numero || !form.archivo) return;
    // Creamos una URL temporal para el archivo
    const archivoUrl = URL.createObjectURL(form.archivo);
    setEmpleados((prev) => [
      ...prev,
      { ...form, archivoUrl, archivoNombre: form.archivo.name },
    ]);
    setForm({ nombre: '', correo: '', numero: '', archivo: null });
    e.target.reset();
  };

  return (
    <div className="App">
      <h2>Registro de Empleado</h2>
      <form onSubmit={handleSubmit} style={{ marginBottom: 30 }}>
        <input
          type="text"
          name="nombre"
          placeholder="Nombre"
          value={form.nombre}
          onChange={handleChange}
          required
          style={{ margin: 5 }}
        />
        <input
          type="email"
          name="correo"
          placeholder="Correo"
          value={form.correo}
          onChange={handleChange}
          required
          style={{ margin: 5 }}
        />
        <input
          type="tel"
          name="numero"
          placeholder="Número"
          value={form.numero}
          onChange={handleChange}
          required
          style={{ margin: 5 }}
        />
        <input
          type="file"
          name="archivo"
          accept="*"
          onChange={handleChange}
          required
          style={{ margin: 5 }}
        />
        <button type="submit" style={{ margin: 5 }}>Guardar</button>
      </form>

      <h3>Empleados Registrados</h3>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {empleados.map((emp, idx) => (
          <li key={idx} style={{ marginBottom: 15, borderBottom: '1px solid #ccc', paddingBottom: 10 }}>
            <strong>Nombre:</strong> {emp.nombre} <br />
            <strong>Correo:</strong> {emp.correo} <br />
            <strong>Número:</strong> {emp.numero} <br />
            <a href={emp.archivoUrl} download={emp.archivoNombre}>Descargar archivo</a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default App;
